module.exports = __webpack_public_path__ + "static/media/ARCreator.f8542085.md";